/**
 * @module utils/aborting
 */

/**
 * @typedef {module:utils/array~Array} Array
 */

import array from './array.js'

/**
 * A function wrapping an abort promise to identify
 * its solving, whatever the abort resolves
 * @param {Promise} abort
 * @return {Array<Promise,symbol>}
 */
export default abort => {
  const symbol = Symbol()
  
  return array([abort.then(() => symbol), symbol])
}
